import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useSetExplanation = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, uuid, claimId} = useContext(OrderContext);


  const explanationFunc = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/set_explanation/`, {
        claim_id : claimId,
        explanation: id
      });
      const data = response.data;
      // setClaimId()
      // console.log("data", data)
     
    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return {explanationFunc};
};

export default useSetExplanation;
